<!--
    描述：系统全局配置
    时间：2020-04-28
    Created by ws
-->
<template>
	<div class="setting-main">
		<el-tooltip effect="dark"
					placement="bottom"
					content="配置">
			<svg-icon icon-class="setting"
					  @click.prevent.stop="showSetting"></svg-icon>
		</el-tooltip>

		<!-- 配置项侧滑 -->
		<el-drawer :with-header="false"
				   :visible.sync="drawerObj.visible"
				   :size="drawerObj.size">
			<h1 class="drawer-title">{{ drawerObj.title }}</h1>
			<div class="setting-item">
				<div class="left">
					是否显示头部
				</div>
				<div class="right">
					<el-switch v-model="isShowHeader"
							   active-text="是"
							   inactive-text="否"
							   @change="handleChange">
					</el-switch>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
	data() {
		return {
			drawerObj: {
				visible: false,
				title: '系统配置项',
				size: '300px'
			},
			isShowHeader: false
		}
	},
	methods: {
		...mapActions('settings', ['changeSetting']),
		// 展示配置侧滑
		showSetting() {
			this.drawerObj.visible = true
		},

		// 切换显示
		handleChange(val) {
			this.drawerObj.visible = false
			setTimeout(() => {
				this.changeSetting({
					key: 'showHeader',
					value: this.isShowHeader
				})
			}, 300)
		}
	},
	created() {
		this.isShowHeader = this.showHeader
	},
	computed: {
		...mapState('settings', {
			showHeader: state => state.showHeader
		})
	}
}
</script>

<style scoped lang="less">
.drawer-title {
	padding: 10px;
	color: #333;
	font-size: 20px;
}

.setting-item {
	height: 30px;
	line-height: 30px;
    padding: 0 10px;
    color: #333;
    font-size: 14px;
	display: flex;
	justify-content: space-between;
}
</style>
